<template>
  <div>
    <div
      v-show="showing"
      class="fixed pt-24 pb-10 inset-0 w-full h-screen flex items-center justify-center bg-semi-75 z-20"
    >
      <div
        class="mx-2 w-10/12 max-h-full bg-white shadow-lg rounded-lg overflow-auto px-4"
      >
        <div class="flex flex-col sticky top-0 bg-white pt-5 z-50">
          <div class="flex">
            <div class="flex w-1/2 justify-start mb-4">
              <h1 style="color: darkblue">Galería</h1>
            </div>
            <div class="flex w-1/2 justify-end mb-4">
              <button
                aria-label="close"
                class="text-xl text-gray-500"
                @click.prevent="close"
              >
                ×
              </button>
            </div>
          </div>
        </div>

        <!-- Gallery -->
        <div class="w-full">
          <!--
            Play with the "justify" value to start from left, center, and right with
            values of "justify-start", "justify-center", and "justify-end"
          -->
          <nav class="text-sm flex justify-start">
            <a
              @click="mediaType = 'Imagenes'"
              class="inline-block px-4 py-2"
              v-bind:class="[
                mediaType === 'Imagenes'
                  ? 'border-b-2 border-indigo-600 text-indigo-600 font-semibold'
                  : 'text-gray-700 hover:text-black',
              ]"
              href="#"
              >Imágenes</a
            >
            <a
              @click="mediaType = 'Videos'"
              class="inline-block px-4 py-2"
              v-bind:class="[
                mediaType === 'Videos'
                  ? 'border-b-2 border-indigo-600 text-indigo-600 font-semibold'
                  : 'text-gray-700 hover:text-black',
              ]"
              href="#"
              >Videos</a
            >
          </nav>
        </div>

        <div
          v-show="mediaType === 'Imagenes'"
          class="grid gap-4 grid-cols-5 z-50"
        >
          <template v-for="(register, index) in multimedia">
            <div
              v-if="register.mimeType.includes('image')"
              class="border-2 shadow-md rounded flex flex-col justify-center items-center"
              :key="'galleryMm' + index"
            >
              <span
                class="py-2 text-primary-color text-sm font-bold tracking-wide"
              >
                {{ register.nombre }}
              </span>
              <v-lazy-image
                :src="replaceURL(register.fileName)"
                class="rounded object-contain"
                style="width: 250px; height: 250px"
                @error="loadDefaultImg"
              />
              <div class="flex flex-col py-2">
                <span class="text-primary-color-dark text-sm">
                  {{ register.nombre_usuario }} {{ register.apellido_usuario }}
                </span>
                <span class="text-gray-500 text-xs">
                  {{ register.TDate }}
                </span>
              </div>
              <div class="pb-2">
                <button
                  @click="zoomOnMap(register)"
                  class="px-4 py-2 bg-primary-color text-white rounded text-sm"
                >
                  Ver en mapa
                </button>
              </div>
            </div>
          </template>
          <!-- <div class="w-1/3 mb-4 mb-lg-0 justify-center">
            <div class="w-full p-4">
              <template v-for="(register, index) in multimedia">
                <template v-if="index%3==0">
                  <template v-show="register.mimeType.includes('image')">
                    <div class="mb-4 flex flex-col p-4">
                      <div class="flex flex-col text-center">
                        <span style='color:darkblue; font-size: 15px;'>
                          {{register.nombre}}
                        </span>
                      </div>
                      <v-lazy-image 
                        @click="openMultimediaModal(register)"
                        :src="replaceURL(register.fileName)"
                        class="shadow-1-strong rounded"
                        style="	min-height: 20%"
                        @error="loadDefaultImg"
                      />
                      <div class="">
                        <div class="flex flex-col">
                          <span style='color: #363f43; font-size: 14px'>
                            {{register.nombre_usuario}} {{register.apellido_usuario}}
                          </span>
                          <span style='font-size: 12px; color:#9d9d9d;'>
                            {{register.TDate}}
                          </span>
                        </div>
                      </div>
                    </div>
                  </template>
                </template>
              </template>
            </div>
          </div> -->

          <!-- <div class="w-1/3 mb-4 mb-lg-0 justify-center">
            <div class="w-full p-4">
              <template v-for="(register, index) in multimedia">
                <template v-if="index%3==1">
                  <template v-show="register.mimeType.includes('image')">
                    <div class="mb-4 flex flex-col p-4">
                      <div class="flex flex-col text-center">
                        <span style='color:darkblue; font-size: 15px;'>
                          {{register.nombre}}
                        </span>
                      </div>
                      <v-lazy-image 
                        @click="openMultimediaModal(register)"
                        :src="replaceURL(register.fileName)"
                        class="shadow-1-strong rounded"
                        style="	min-height: 20%"
                        @error="loadDefaultImg"
                      />
                      <div class="">
                        <div class="flex flex-col">
                          <span style='color: #363f43; font-size: 14px'>
                            {{register.nombre_usuario}} {{register.apellido_usuario}}
                          </span>
                          <span style='font-size: 12px; color:#9d9d9d;'>
                            {{register.TDate}}
                          </span>
                        </div>
                      </div>
                    </div>
                  </template>
                </template>
              </template>
            </div>
          </div> -->

          <!-- <div class="w-1/3 mb-4 mb-lg-0 justify-center">
            <div class="w-full p-4">
              <template v-for="(register, index) in multimedia">
                <template v-if="index%3==2">
                  <template v-show="register.mimeType.includes('image')">
                    <div class="mb-4 flex flex-col p-4">
                      <div class="flex flex-col text-center">
                        <span style='color:darkblue; font-size: 15px;'>
                          {{register.nombre}}
                        </span>
                      </div>
                      <v-lazy-image 
                        @click="openMultimediaModal(register)"
                        :src="replaceURL(register.fileName)"
                        class="shadow-1-strong rounded"
                        style="	min-height: 20%"
                        @error="loadDefaultImg"
                      />
                      <div class="">
                        <div class="flex flex-col">
                          <span style='color: #363f43; font-size: 14px'>
                            {{register.nombre_usuario}} {{register.apellido_usuario}}
                          </span>
                          <span style='font-size: 12px; color:#9d9d9d;'>
                            {{register.TDate}}
                          </span>
                        </div>
                      </div>
                    </div>
                  </template>
                </template>
              </template>
            </div>
          </div> -->
        </div>

        <div
          v-show="mediaType === 'Videos'"
          class="grid gap-4 grid-cols-5 z-50"
        >
          <template v-for="(register, index) in multimedia">
            <div
              v-if="register.mimeType.includes('video')"
              class="border-2 shadow-md rounded flex flex-col justify-center items-center"
              :key="'galleryMm' + index"
            >
              <span
                class="py-2 text-primary-color text-sm font-bold tracking-wide"
              >
                {{ register.nombre }}
              </span>
              <video
                :src="replaceURL(register.fileName)"
                class="rounded object-contain"
                style="width: 250px; height: 250px"
                controls
              ></video>
              <div class="flex flex-col py-2">
                <span class="text-primary-color-dark text-sm">
                  {{ register.nombre_usuario }} {{ register.apellido_usuario }}
                </span>
                <span class="text-gray-500 text-xs">
                  {{ register.TDate }}
                </span>
              </div>
              <div class="pb-2">
                <button
                  @click="zoomOnMap(register)"
                  class="px-4 py-2 bg-primary-color text-white rounded text-sm"
                >
                  Ver en mapa
                </button>
              </div>
            </div>
          </template>
          <!-- <div class="w-1/3 mb-4 mb-lg-0 justify-center">
            <div class="w-full p-4">
              <template v-for="(register, index) in multimedia">
                <template v-if="index % 3 == 0">
                  <template v-if="register.mimeType.includes('video')">
                    <div class="mb-4 flex flex-col p-4">
                      <div class="flex flex-col text-center">
                        <span style="color: darkblue; font-size: 15px">
                          {{ register.nombre }}
                        </span>
                      </div>
                      <video
                        :src="replaceURL(register.fileName)"
                        class="w-full"
                        controls
                      ></video>
                      <div class="">
                        <div class="flex flex-col">
                          <span style="color: #363f43; font-size: 14px">
                            {{ register.nombre_usuario }}
                            {{ register.apellido_usuario }}
                          </span>
                          <span style="font-size: 12px; color: #9d9d9d">
                            {{ register.TDate }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </template>
                </template>
              </template>
            </div>
          </div> -->

          <!-- <div class="w-1/3 mb-4 mb-lg-0 justify-center">
            <div class="w-full p-4">
              <template v-for="(register, index) in multimedia">
                <template v-if="index % 3 == 1">
                  <template v-if="register.mimeType.includes('video')">
                    <div class="mb-4 flex flex-col p-4">
                      <div class="flex flex-col text-center">
                        <span style="color: darkblue; font-size: 15px">
                          {{ register.nombre }}
                        </span>
                      </div>
                      <video
                        :src="replaceURL(register.fileName)"
                        class="w-full"
                        controls
                      ></video>
                      <div class="">
                        <div class="flex flex-col">
                          <span style="color: #363f43; font-size: 14px">
                            {{ register.nombre_usuario }}
                            {{ register.apellido_usuario }}
                          </span>
                          <span style="font-size: 12px; color: #9d9d9d">
                            {{ register.TDate }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </template>
                </template>
              </template>
            </div>
          </div> -->

          <!-- <div class="w-1/3 mb-4 mb-lg-0 justify-center">
            <div class="w-full p-4">
              <template v-for="(register, index) in multimedia">
                <template v-if="index % 3 == 2">
                  <template v-if="register.mimeType.includes('video')">
                    <div class="mb-4 flex flex-col p-4">
                      <div class="flex flex-col text-center">
                        <span style="color: darkblue; font-size: 15px">
                          {{ register.nombre }}
                        </span>
                      </div>
                      <video
                        :src="replaceURL(register.fileName)"
                        class="w-full"
                        controls
                      ></video>
                      <div class="">
                        <div class="flex flex-col">
                          <span style="color: #363f43; font-size: 14px">
                            {{ register.nombre_usuario }}
                            {{ register.apellido_usuario }}
                          </span>
                          <span style="font-size: 12px; color: #9d9d9d">
                            {{ register.TDate }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </template>
                </template>
              </template>
            </div>
          </div> -->
        </div>
        <!-- Gallery -->
        <div class="flex w-full sticky bottom-0 justify-end pb-5 mt-4 bg-white">
          <button
            class="ml-2 bg-purple-500 hover:bg-purple-700 px-4 py-2 text-center rounded-lg text-gray-100 tracking-wide"
            @click="close()"
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>

    <multimedia-modal
      :showing="showingMultimedia"
      :multimedia="currentMultimedia"
      @close="showingMultimedia = false"
    ></multimedia-modal>
  </div>
</template>

<script>
import MultimediaModal from "./MultimediaModal";
import urlMixin from "@/mixins/urlMixin";
export default {
  mixins: [urlMixin],
  name: "multimedia-gallery-modal",
  data() {
    return {
      mediaType: "Imagenes",
      showingMultimedia: false,
      currentMultimedia: {},
    };
  },
  props: {
    showing: {
      required: true,
      type: Boolean,
    },
    multimedia: {
      required: true,
    },
  },
  components: {
    MultimediaModal,
  },
  mounted() {
  },
  methods: {
    close() {
      this.$emit("close");
    },

    openMultimediaModal(register) {
      this.currentMultimedia = register;
      this.showingMultimedia = true;
    },
    loadDefaultImg(event) {
      event.target.src = "@/assets/default-image-sm.jpg";
    },
    zoomOnMap(multimedia) {
      let multimediaSelected = {};
      multimediaSelected.id = multimedia.id;
      let coords = [multimedia.latitud, multimedia.longitud];
      multimediaSelected.coords = coords;
      this.$emit("zoom", multimediaSelected);
    },
  },
};
</script>

<style scoped>
.bg-semi-75 {
  background-color: rgba(0, 0, 0, 0.75);
}
</style>
